import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const cropList = createAsyncThunk('cropList', async ({ pageable: data, navigate }) => {

	try {
		const res = await axios({

			method: 'GET',
			url: process.env.REACT_APP_API_URL + `crop`,
			params: {
				'pageSize': data?.pageSize,
				'pageNo': data?.currentPage,
				'search': data?.search,
			},
			headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

		})
		return res
	} catch (error) {
		return error.response
	}
})

const cropListSlice = createSlice({
	name: 'cropList',
	initialState: {
		data: [],
	},
	extraReducers: (builder) => {
		builder.addCase(cropList.fulfilled, (state, action) => {
			if (action?.payload?.status === 200) {
				state.data = action.payload.data.data;
			} else if (action?.payload?.status === 401) {
				showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
			} else if (action?.payload?.status === 403) {
				showAccessDeniedAlert(action.meta.arg.navigate)
			} else {
				state.data = []
			}

		});
		builder.addCase(cropList.rejected, (state, action) => {
			// console.log('reject', action)
		})
	}
})

export default cropListSlice.reducer; 